// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import SentToUserSvg from '@rsuite/icon-font/lib/people/SentToUser';
var SentToUser = createSvgIcon({
  as: SentToUserSvg,
  ariaLabel: 'sent to user',
  category: 'people',
  displayName: 'SentToUser'
});
export default SentToUser;